import videoAdapter from './video';
import blocksController from './blocksController';
import articleSelectorController from './articleSelectorController';
import preload from './load/preload';
import preloader from './preloader';
import {analyticsEvent} from '../../../analytics';
import routerController from './router';
const videoBlocks = [...document.querySelectorAll('.video')];
const sectionBlocks = [...document.querySelectorAll('.articles-container .section')];
const body = document.body;
const data = require('./data/data');
const sections = data.sections;
const sectionLabelButtons = [...document.querySelectorAll('.section-selector-container .label')];
const mobileMenuButtons = [...document.querySelectorAll('.menu__articles-list .menu__articles-list-item')];
// videoAdapter.play(videoId, [video section from data], [loop boolean]);

const videoIndex = {
    '0': 'videoPreload',
    '1': 'videoOne',
    '2': 'videoTwo',
    '3': 'videoThree'
};

const stateController = (function() {
    // const initialSection = 0;
    let currentSection;
    let currentArticle = 0;
    let chosenArticle = undefined;
    function _showVideo(blockId) {
        videoBlocks.forEach(block => {
            if (block.dataset.video === blockId) {
                block.classList.add('show');
            } else {
                block.classList.remove('show');
            }
        });
    }
    function init() {
        // switchSection(initialSection);
        // routerController.goto(initialSection);
        // _showVideo('videoPreload');
        // articleSelectorController.init(initialSection);
        // videoAdapter.play('videoPreload', 0, true);
        sectionLabelButtons.forEach(button => {
            button.addEventListener('click', () => {
                // switchSection(parseInt(button.dataset.section));
                routerController.goto(parseInt(button.dataset.section));
            });
        });
        mobileMenuButtons.forEach(button => {
            button.addEventListener('click', () => {
                // switchSection(parseInt(button.dataset.section));
                routerController.goto(parseInt(button.dataset.section));
            });
        });
    }
    function switchSection(sectionId) {
        if (currentSection === sectionId) {
            return;
        }
        document.body.dataset.showlinks = false;
        const changeSection = () => {
            articleSelectorController.init(parseInt(sectionId));
            body.dataset.section = sectionId;
            analyticsEvent('Section', 'Goto', `Переход к ${sectionId} разделу`);
            setTimeout(() => {
                currentSection = sectionId;
                currentArticle = 0;
                blocksController.show(sectionId, 0);
                sectionBlocks.forEach(section => {
                    if (parseInt(section.dataset.section) === sectionId) {
                        section.classList.add('show');
                    } else {
                        section.classList.remove('show');
                    }
                });
                _showVideo(sections[sectionId].videoId);
                videoAdapter.play(sections[sectionId].videoId, 0, sections[sectionId].article[0].loop);
            }, 700);
        };
        const vidState = preload.getVideoState();
        if (vidState[videoIndex[sectionId]].loaded) {
            changeSection();
        } else {
            // TODO: добавить типа прелоадер между разделами
            preloader.show();
            const loadcounter = setInterval(function() {
                if (vidState[videoIndex[sectionId]].loaded) {
                    changeSection();
                    clearInterval(loadcounter);
                }
            }, 100);
        }
    }
    function next() {
        if (data.sections[currentSection].article.length - 1 === currentArticle) {
            if (currentSection === data.sections.length - 1) {
                return;
            }
            // switchSection(currentSection + 1);
            routerController.goto(currentSection + 1);
            return;
        }
        gotoArticle(currentArticle + 1);
        /*
        blocksController.hide(currentSection);
        if (sections[currentSection].article[currentArticle].interval === sections[currentSection].article[currentArticle + 1].interval) {
            videoAdapter.endAndPlayNext('resume');
        } else {
            if (currentSection === 1) {
                videoAdapter.playNext('end');
                return;
            }
            videoAdapter.endAndPlayNext('end');
        }
        */
    }
    function prev() {
        if (currentArticle === 0) {
            if (currentSection === 0) {
                return;
            }
            // switchSection(currentSection - 1);
            routerController.goto(currentSection - 1);
            return;
        }
        gotoArticle(currentArticle - 1);
    }
    function gotoArticle(articleIndex) {
        blocksController.hide(currentSection);
        chosenArticle = +articleIndex;
        analyticsEvent(`Section ${currentSection}`, 'Goto', `Переход к ${chosenArticle} части`);
        if (sections[currentSection].article[currentArticle].interval === sections[currentSection].article[+articleIndex].interval) {
            videoAdapter.endAndPlayNext('resume');
        } else {
            if (currentSection === 1) {
                videoAdapter.endAndPlayNext('end');
                return;
            }
            videoAdapter.endAndPlayNext('end');
        }
    }
    function stateVideo(command) {
        if (chosenArticle !== undefined) {
            currentArticle = chosenArticle;
            chosenArticle = undefined;
        } else {
            ++currentArticle;
        }
        switch (command) {
            case 'resume':
                blocksController.show(currentSection, currentArticle);
                break;
            default:
                blocksController.show(currentSection, currentArticle);
                videoAdapter.play(
                    sections[currentSection].videoId,
                    sections[currentSection].article[currentArticle].interval,
                    sections[currentSection].article[currentArticle].loop
                );
                break;
        }
    }
    function getState() {
        const state = {
            currentSection: currentSection,
            currentArticle: currentArticle
        };
        return state;
    }
    return {
        init: init,
        switchSection: switchSection,
        next: next,
        prev: prev,
        getState: getState,
        gotoArticle: gotoArticle,
        stateVideo: stateVideo
    };
})();
export default stateController;
